const styles = theme => ({
  root: {
    position: 'relative',
    minHeight: '100vh',
    overflow: 'hidden',
    background: '#FFFFFF',
    padding: '65px 10% 0',
    [theme.breakpoints.down('xs')]: {
      padding: '70px 20px 50px',
    },
  },
  mobileOrder1: {
    [theme.breakpoints.down('sm')]: {
      order: '1',
    },
  },
  mobileOrder2: {
    [theme.breakpoints.down('sm')]: {
      order: '2',
    },
  },
  header1: {
    margin: '0',
    fontSize: '2.25rem',
    width: '90%',
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.5rem',
    },
  },
  spacingBottom: {
    marginBottom: '30px',
  },
  fullWidth: {
    width: '100%',
  },
  width80: {
    width: '80%',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
  fullHeight: {
    height: '100vh',
  },
  imgFuncDisabled: {
    pointerEvents: 'none',
  },
});

export default styles;
